import React from 'react';

// Inline alert block — replaces the repeated ad-hoc
// `rounded bg-red-50 p-2 text-xs text-red-700` / emerald success blocks.
// Semantic washes intentionally stay light in both themes (consistent with
// the app's existing alerts; red/amber are unthemed by design).

type Tone = 'error' | 'success' | 'warning' | 'info';

const TONE: Record<Tone, string> = {
  error: 'bg-red-50 text-red-700',
  success: 'border border-emerald-200 bg-emerald-50 text-emerald-900',
  warning: 'bg-amber-50 text-amber-800',
  info: 'bg-slate-100 text-slate-600',
};

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  tone?: Tone;
  title?: string;
}

export function Alert({ tone = 'error', title, className, children, ...rest }: AlertProps) {
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={['rounded p-2 text-xs', TONE[tone], className ?? ''].join(' ')}
      {...rest}
    >
      {title && <div className="mb-0.5 font-semibold">{title}</div>}
      {children}
    </div>
  );
}
